var render = function () {
  var _vm$accountBalance;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card meta"
  }, [_vm.$vuetify.breakpoint.smAndDown ? _c('header', {
    staticClass: "header"
  }, [_vm._v(" Address "), _c('span', {
    staticClass: "address"
  }, [_c('br'), _vm._v(" " + _vm._s(_vm.address) + " "), _c('CopyText', {
    attrs: {
      "value": _vm.address
    }
  })], 1)]) : _c('header', {
    staticClass: "header"
  }, [_vm._v(" Address "), _c('span', {
    staticClass: "address"
  }, [_vm._v(_vm._s(_vm.address) + " "), _c('CopyText', {
    attrs: {
      "value": _vm.address
    }
  })], 1)]), _c('div', {
    staticClass: "card overview"
  }, [_c('h4', [_vm._v("Overview")]), _c('article', [_c('label', [_vm._v("Balance")]), _c('p', {
    staticClass: "dcm-after"
  }, [_vm._v(" " + _vm._s((_vm$accountBalance = _vm.accountBalance) === null || _vm$accountBalance === void 0 ? void 0 : _vm$accountBalance.toLocaleString('en-US')) + " ")])]), _c('article', [_vm._m(0), _c('p', {
    staticClass: "usd-after"
  }, [_vm._v("$ " + _vm._s(_vm.inUSD.toLocaleString('en-US')))])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', [_vm._v("DCM value"), _c('sup', [_vm._v("Test")])]);
}]

export { render, staticRenderFns }